import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum JourneyCustomerStatusEnum {
    NEW = "f32859d1-9456-4fbd-9d51-6b692ea5e395",
    ACTIVE = "42c6f00f-ad0f-45ca-9cb6-5a5077c59c1d",
    EXPIRED = "8d908290-8605-44ed-8af9-a4f5458d86ab",
    REPEAT = "45378906-41bf-4abb-bd26-dd11b2802256",
}

export const journeyCustomerStatuses: Record<JourneyCustomerStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [JourneyCustomerStatusEnum.NEW]: {
        id: "f32859d1-9456-4fbd-9d51-6b692ea5e395" as Uuid,
        displayName: "Live"
    },
    [JourneyCustomerStatusEnum.ACTIVE]: {
        id: "42c6f00f-ad0f-45ca-9cb6-5a5077c59c1d" as Uuid,
        displayName: "Converted"
    },
    [JourneyCustomerStatusEnum.EXPIRED]: {
        id: "8d908290-8605-44ed-8af9-a4f5458d86ab" as Uuid,
        displayName: "Churned"
    },
    [JourneyCustomerStatusEnum.REPEAT]: {
        id: "45378906-41bf-4abb-bd26-dd11b2802256" as Uuid,
        displayName: "Closed"
    },
};
